import { tsValidateArray, tsValidateBoolean, tsValidateExists, tsValidateNumber, tsValidateOptionalId, tsValidateOptionalObject, tsValidateResult, tsValidateString, tsValidateTimestamp, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { EncounterStatuses } from './types.js';
import { AdvisorRuntimeIDBGroup } from '../runtime/_core/index.js';
const periodValidator = (period) => {
    if (!period)
        return;
    return tsValidateResult(period, { start: tsValidateNumber(false), end: tsValidateNumber(false) });
};
const Validator_ModifiableProps = {
    patientId: tsValidateUniqueId,
    endedEncounter: tsValidateBoolean(),
    artifactMetadata: tsValidateExists(),
    initEncounterTimestamp: tsValidateTimestamp(),
    advisorConfigurationId: tsValidateUniqueId,
    ehrInstanceId: tsValidateUniqueId,
    encounterId: tsValidateUniqueId,
    sessionId: tsValidateUniqueId,
    kbVersion: tsValidateString(),
    encounterStatus: tsValidateValue(EncounterStatuses),
    period: periodValidator,
    participants: tsValidateArray({
        id: tsValidateUniqueId,
        displayName: tsValidateString(undefined, false),
        period: periodValidator,
        type: tsValidateArray({
            code: tsValidateArray(tsValidateString()),
            text: tsValidateString()
        })
    }, false),
    advisorConfig: {
        enableSurvey: tsValidateBoolean(),
        devInstance: tsValidateBoolean()
    },
    dispositionData: tsValidateOptionalObject({
        dispositionDecision: tsValidateString(),
        diagnosisVariable: tsValidateOptionalId,
        dispositionTimestamp: tsValidateTimestamp()
    })
};
const Validator_GeneratedProps = {};
export const DBDef_EncounterMetadata = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.4', '1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'encounter-metadata',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'encounter-metadata'
    },
    backend: {
        name: 'encounter-metadata',
    },
    entityName: 'PatientEncounter',
};
//# sourceMappingURL=db-def.js.map